// extracted by mini-css-extract-plugin
export default {"page":"MGPage_page__nfmI7","mobileViewport":"MGPage_mobileViewport__k5lfL","body":"MGPage_body__PchxF","content":"MGPage_content__41DB+"};